import React, { FC } from 'react';

import { Select } from '@rbilabs/components-library/build/components/select';

import { IBankSelectProps } from './types';

const BankSelect: FC<IBankSelectProps> = ({ banks, ...otherProps }) => {
  let options: { label: string; value: string | '' }[] = banks.map(bank => ({
    label: bank.name,
    value: bank.id,
  }));

  return <Select options={options} required {...otherProps} />;
};

export default BankSelect;
